import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    coinTypes: []
  },
  getters: {
    list: state => {
      return state.datas.map(item => ({
        ...item
      }));
    }
  },
  mutations: {
    setCoinTypes(state, payload) {
      state.coinTypes = payload;
    },
  },
  actions: {
    getCoinTypes({ commit }) {
      api.getCoinTypes().then(({ data }) => {
        commit('setCoinTypes', data);
      });
    }
  }
};

appStore.registerModule('transferPsiSettle', store);
